import { useEffect, useState } from 'react';
import * as R from 'ramda';

const useFilterCount = (cardsFilters, defaultState) => {
  const [filterCount, setFilterCount] = useState(0);

  useEffect(() => {
    const filterOut = ({ label, value }) => !R.equals(value, defaultState[label]);
    R.compose(
      setFilterCount,
      R.length,
      R.filter(filterOut),
      R.map(R.applySpec({ label: R.head, value: R.last })),
      R.toPairs
    )(cardsFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsFilters]);

  return { filterCount };
};

export default useFilterCount;
